import moment from 'moment';
moment.locale('ru');
function getDisplayDateFromSelectedDate(selectedDate) {
    if (selectedDate === void 0) { selectedDate = ''; }
    var momentToday = moment();
    var _a = selectedDate.split('.'), _b = _a[1], month = _b === void 0 ? momentToday.month() + 1 : _b, _c = _a[2], year = _c === void 0 ? momentToday.year() : _c;
    // Мы должны убедиться, что, месяц и год валидны с точки зрения даты. Если нет - заменить месяц на текущий. Любой год в котором есть 4 цифры будет валиден с точки зрения этой проверки, в противном случае мы показываем текущий год
    month = parseInt(String(month || 0), 10);
    if (month < 1 || month > 12) {
        month = momentToday.month() + 1;
    }
    if (!year || String(year).length !== 4) {
        year = momentToday.year();
    }
    return moment("01." + month + "." + year, 'DD.MM.YYYY');
}
// eslint-disable-next-line import/prefer-default-export
export function getDisplayDate(displayDate, selectedDate) {
    if (displayDate === void 0) { displayDate = ''; }
    if (selectedDate === void 0) { selectedDate = ''; }
    var momentDisplayDate = moment(displayDate, 'DD.MM.YYYY');
    if (momentDisplayDate.isValid()) {
        return momentDisplayDate;
    }
    return getDisplayDateFromSelectedDate(selectedDate);
}
//# sourceMappingURL=helpers.js.map